import React from 'react';
import {Paper, Stack, Typography} from '@mui/material';
import {PdfFile} from 'hooks/useSigningDemo';
import {useTranslate} from 'hooks/useTranslate';
import {AgreementTypeSelect} from './AgreementTypeSelect';
import {PdfUploadButton} from './PdfUploadButton';

interface MainDocumentBoxProps {
  file: PdfFile;
  agreementType: string;
  onFileChange: (file: PdfFile) => void;
  onAgreementTypeChange: (agreementType: string) => void;
}

export const MainDocumentBox = ({
  file,
  agreementType,
  onFileChange,
  onAgreementTypeChange,
}: MainDocumentBoxProps) => {
  const t = useTranslate();

  return (
    <Paper variant="outlined" sx={{p: 2}}>
      <Stack spacing={2}>
        <Typography variant="h6" component="h2">
          {t('demo.signing.documents.main.title')}
        </Typography>
        <PdfUploadButton
          label={t('demo.signing.documents.main.file')}
          file={file}
          onChange={onFileChange}
        />
        <AgreementTypeSelect
          value={agreementType}
          onChange={onAgreementTypeChange}
          sx={{alignSelf: 'flex-start'}}
        />
      </Stack>
    </Paper>
  );
};
